import { render, staticRenderFns } from "./nav-bar-deploy.vue?vue&type=template&id=b96cb8fa&scoped=true&"
import script from "./nav-bar-deploy.vue?vue&type=script&lang=js&"
export * from "./nav-bar-deploy.vue?vue&type=script&lang=js&"
import style0 from "./nav-bar-deploy.vue?vue&type=style&index=0&id=b96cb8fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96cb8fa",
  null
  
)

export default component.exports